import { useContext, useEffect } from 'react';
import { ModalManagerContext } from './ModalManagerProvider';
import { ModalType } from './modalType';
export function Modal(_ref) {
  let {
    children,
    type = ModalType.OTHER,
    id
  } = _ref;
  const {
    register,
    shouldRender,
    unregister,
    isIdRegistered
  } = useContext(ModalManagerContext);
  useEffect(() => {
    if (!isIdRegistered(type, id)) {
      register(type, id);
    }
    return function clean() {
      unregister(type, id);
    };
  }, [id, type, isIdRegistered, register, unregister]);
  return shouldRender(type, id) ? children({
    closeHandler: () => unregister(type, id)
  }) : null;
}